<form [formGroup]="form" class="mat-typography" *ngIf="form">
    <div *ngIf="form.invalid" class="form-error-banner">
        <mat-error *ngIf="form.hasError('requireOneIncludeTarget')">
            At least one Include target (Users, Groups, or Domains) is required.
        </mat-error>

       <mat-error *ngIf="form.hasError('requireCustomNotificationText')">
            Custom notification text is required.
        </mat-error>
    </div>

    <mat-accordion multi>
        <!-- Settings -->
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Settings </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('Identity!') ||
                                errorsString.includes('Priority!') ||
                                errorsString.includes('EnableSafeLinksForEmail!') ||
                                errorsString.includes('EnableForInternalSenders!') ||
                                errorsString.includes('ScanUrls!') ||
                                errorsString.includes('DeliverMessageAfterScan!') ||
                                errorsString.includes('DisableUrlRewrite!') ||
                                errorsString.includes('DoNotRewriteUrls!') ||
                                errorsString.includes('EnableSafeLinksForTeams!') ||
                                errorsString.includes('EnableSafeLinksForOffice!') ||
                                errorsString.includes('TrackClicks!') ||
                                errorsString.includes('AllowClickThrough!') ||
                                errorsString.includes('EnableOrganizationBranding!') || !policy
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="flex-data">
                                Identity
                                <mat-icon matTooltip="The display name for this Safe Links policy.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy?.Identity || 'No policy' }}</td>
                        <td>{{ formValue?.Identity }}</td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Identity!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <!-- Email section -->
                    <tr>
                        <td colspan="4"><strong>Email</strong></td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                On: Safe Links checks a list of known, malicious links when users click links in email. URLs are rewritten by default.
                                <mat-icon matTooltip="Enable Safe Links scanning for email messages.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.EnableSafeLinksForEmail ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="EnableSafeLinksForEmail">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('EnableSafeLinksForEmail!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="enableSafeLinksForEmail">
                        <td>
                            <div class="flex-data">
                                Apply Safe Links to email messages sent within the organization
                                <mat-icon matTooltip="Apply Safe Links to internal email messages.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.EnableForInternalSenders ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="EnableForInternalSenders">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('EnableForInternalSenders!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="enableSafeLinksForEmail">
                        <td>
                            <div class="flex-data">
                                Apply real-time URL scanning for suspicious links and links that point to files
                                <mat-icon matTooltip="Enable real-time URL scanning.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.ScanUrls ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="ScanUrls">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('ScanUrls!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="enableSafeLinksForEmail && scanUrls">
                        <td>
                            <div class="flex-data">
                                Wait for URL scanning to complete before delivering the message
                                <mat-icon matTooltip="Wait for URL scanning before delivery.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.DeliverMessageAfterScan ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="DeliverMessageAfterScan">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('DeliverMessageAfterScan!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                          <tr *ngIf="enableSafeLinksForEmail">
                        <td>
                            <div class="flex-data">
                                Do not rewrite URLs, do checks via Safe Links API only
                                <mat-icon matTooltip="Do checks via Safe Links API only.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.DisableUrlRewrite ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="DisableUrlRewrite">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('DisableUrlRewrite!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Do not rewrite the following URLs in email
                                <mat-icon matTooltip="URLs that Safe Links should not rewrite.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.DoNotRewriteUrls?.length > 0">
                                <div *ngFor="let item of policy.DoNotRewriteUrls">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.DoNotRewriteUrls?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="DoNotRewriteUrls"
                                [multiple]="true"
                                [addTag]="addUrlTag"
                                addTagText="Add URL"
                                [appendTo]="'body'"
                                placeholder="e.g. https://contoso.com/*">
                            </ng-select>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('DoNotRewriteUrls!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>



                    <!-- Teams section -->
                    <tr>
                        <td colspan="4"><strong>Teams</strong></td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                On: Safe Links checks a list of known, malicious links when users click links in Microsoft Teams. URLs are rewritten by default.
                                <mat-icon matTooltip="Enable Safe Links for Microsoft Teams.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.EnableSafeLinksForTeams ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="EnableSafeLinksForTeams">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('EnableSafeLinksForTeams!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <!-- Office 365 Apps section -->
                    <tr>
                        <td colspan="4"><strong>Office 365 Apps</strong></td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                On: Safe Links checks a list of known, malicious links when users click links in Microsoft Office apps. URLs are not rewritten.
                                <mat-icon matTooltip="Enable Safe Links for Office 365 apps.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.EnableSafeLinksForOffice ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="EnableSafeLinksForOffice">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('EnableSafeLinksForOffice!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <!-- Click protection settings -->
                    <tr>
                        <td colspan="4"><strong>Click protection settings</strong></td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Track user clicks
                                <mat-icon matTooltip="Track when users click links.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.TrackClicks ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="TrackClicks">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('TrackClicks!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="trackClicks">
                        <td>
                            <div class="flex-data">
                                Let users click through to the original URL
                                <mat-icon matTooltip="Allow users to click through to the original URL.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.AllowClickThrough ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="AllowClickThrough">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('AllowClickThrough!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="trackClicks">
                        <td>
                            <div class="flex-data">
                                Display the organization branding on notification and warning pages
                                <mat-icon matTooltip="Show organization branding on Safe Links warning pages.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.EnableOrganizationBranding ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="EnableOrganizationBranding">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('EnableOrganizationBranding!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Priority
                                <mat-icon matTooltip="The priority of the Safe Links rule. Lower number means higher priority.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy?.Priority ?? '-' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <input [readonly]="true" formControlName="Priority" matInput type="number" min="0" placeholder="0" />
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Priority') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>

        <!-- Notification -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Notification </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('EnableMicrosoftTranslator!') ||
                                errorsString.includes('CustomNotificationText!') ||
                                    form.hasError('requireCustomNotificationText')
                               || formValue.useCustomNotification !== !!policy?.CustomNotificationText || !policy
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>How would you like to notify your users?</td>
                        <td>
                            {{ policy ? (policy?.CustomNotificationText ? 'Custom notification' : 'Default notification') : 'No policy' }}
                        </td>
                        <td>
                            <mat-radio-group formControlName="useCustomNotification" class="flex flex-col gap-2">
                                <mat-radio-button [value]="false">Use the default notification text</mat-radio-button>
                                <mat-radio-button [value]="true">Use custom notification text</mat-radio-button>
                            </mat-radio-group>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="!policy || formValue.useCustomNotification !== !!policy?.CustomNotificationText"></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="useCustomNotification">
                        <td>
                            <div class="flex-data">
                                Use Microsoft Translator for automatic localization
                                <mat-icon matTooltip="Automatically translate custom notification text.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.EnableMicrosoftTranslator ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-checkbox formControlName="EnableMicrosoftTranslator">
                                Use Microsoft Translator for automatic localization
                            </mat-checkbox>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('EnableMicrosoftTranslator!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="useCustomNotification">
                        <td>Custom notification text</td>
                        <td>{{ policy?.CustomNotificationText || '-' }}</td>
                        <td>
                            <mat-form-field appearance="fill" class="w-full">
                                <textarea formControlName="CustomNotificationText" matInput rows="3" placeholder="Enter custom notification text..."></textarea>
                                <mat-error *ngIf="form.hasError('requireCustomNotificationText')">
                                    Custom notification text is required.
                                </mat-error>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="
                                    errorsString.includes('CustomNotificationText!') ||
                                    form.hasError('requireCustomNotificationText') ||
                                    !policy
                                "
                            ></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>

        <!-- Include Targets -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Include </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('SentTo!') ||
                                errorsString.includes('SentToMemberOf!') ||
                                errorsString.includes('RecipientDomainIs!') || !policy
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>
            <div *ngIf="includeTargetError">
                <mat-error>At least one Include target (Users, Groups, or Domains) is required.</mat-error>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="flex-data">
                                Include Users
                                <mat-icon matTooltip="Apply this policy to messages sent to specific users.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.SentTo?.length > 0">
                                <div *ngFor="let item of policy.SentTo">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.SentTo?.length">-</span>
                        </td>
                        <td>
                            <ng-select formControlName="SentTo" [items]="users$ | async" [multiple]="true" bindLabel="name" bindValue="name" [appendTo]="'body'" placeholder="Include Users"></ng-select>
                            <mat-error *ngIf="sentToErrors?.length > 0">Invalid email(s): {{ sentToErrors.join(', ') }}</mat-error>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('SentTo!') || !policy"></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Include Groups
                                <mat-icon matTooltip="Apply this policy to messages sent to members of specific groups.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.SentToMemberOf?.length > 0">
                                <div *ngFor="let item of policy.SentToMemberOf">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.SentToMemberOf?.length">-</span>
                        </td>
                        <td>
                            <ng-select formControlName="SentToMemberOf" [items]="groups$ | async" [multiple]="true" bindLabel="name" bindValue="mail" [appendTo]="'body'" placeholder="Include Groups"></ng-select>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('SentToMemberOf') || !policy"></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Include Domains
                                <mat-icon matTooltip="Apply this policy to messages sent to recipients in specific domains.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.RecipientDomainIs?.length > 0">
                                <div *ngFor="let item of policy.RecipientDomainIs">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.RecipientDomainIs?.length">-</span>
                        </td>
                        <td>
                            <ng-select formControlName="RecipientDomainIs" [items]="domains$ | async" [multiple]="true" bindLabel="name" bindValue="name" [appendTo]="'body'" placeholder="Include Domains"></ng-select>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('RecipientDomainIs') || !policy"></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>

        <!-- Exclude Targets -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Exclude </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('ExceptIfSentTo!') ||
                                errorsString.includes('ExceptIfSentToMemberOf!') ||
                                errorsString.includes('ExceptIfRecipientDomainIs!')
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="flex-data">
                                Exclude Users
                                <mat-icon matTooltip="Exclude specific users from this policy.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.ExceptIfSentTo?.length > 0">
                                <div *ngFor="let item of policy.ExceptIfSentTo">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.ExceptIfSentTo?.length">-</span>
                        </td>
                        <td>
                            <ng-select formControlName="ExceptIfSentTo" [items]="users$ | async" [multiple]="true" bindLabel="name" bindValue="name" [appendTo]="'body'" placeholder="Exclude Users"></ng-select>
                            <mat-error *ngIf="exceptIfSentToErrors?.length > 0">Invalid email(s): {{ exceptIfSentToErrors.join(', ') }}</mat-error>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('ExceptIfSentTo!') || !policy"></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Exclude Groups
                                <mat-icon matTooltip="Exclude members of specific groups from this policy.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.ExceptIfSentToMemberOf?.length > 0">
                                <div *ngFor="let item of policy.ExceptIfSentToMemberOf">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.ExceptIfSentToMemberOf?.length">-</span>
                        </td>
                        <td>
                            <ng-select formControlName="ExceptIfSentToMemberOf" [items]="groups$ | async" [multiple]="true" bindLabel="name" bindValue="mail" [appendTo]="'body'" placeholder="Exclude Groups"></ng-select>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('ExceptIfSentToMemberOf') || !policy"></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Exclude Domains
                                <mat-icon matTooltip="Exclude recipients in specific domains from this policy.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.ExceptIfRecipientDomainIs?.length > 0">
                                <div *ngFor="let item of policy.ExceptIfRecipientDomainIs">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.ExceptIfRecipientDomainIs?.length">-</span>
                        </td>
                        <td>
                            <ng-select formControlName="ExceptIfRecipientDomainIs" [items]="domains$ | async" [multiple]="true" bindLabel="name" bindValue="name" [appendTo]="'body'" placeholder="Exclude Domains"></ng-select>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('ExceptIfRecipientDomainIs') || !policy"></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>
    </mat-accordion>
</form>
